import { cmds } from "effects";

export function* logout() {
  yield cmds.gateway("/logout", {});
  yield cmds.redirect("/");
}
